import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">&copy; {new Date().getFullYear()} Vedant Marathe. All Rights not Reserved :D</p>
      </div>
    </footer>
  );
}

export default Footer;
